import { addFolderToDefaultFolderMappings } from 'owa-session-store';
import type * as Schema from 'owa-graph-schema';

export default function addArchiveMappingsInSessionStore(
    archiveRootFolder: Schema.MailFolder,
    folders: Schema.MailFolder[]
) {
    // Add archive root folder mapping to the session store
    addFolderToDefaultFolderMappings(
        archiveRootFolder.DistinguishedFolderId,
        archiveRootFolder.FolderId.Id
    );

    // Only add the distinguished children of archive root to the session store
    folders
        .filter(
            folder =>
                folder.DistinguishedFolderId &&
                folder.ParentFolderId.Id == archiveRootFolder.FolderId.Id
        )
        .forEach(folder =>
            addFolderToDefaultFolderMappings(folder.DistinguishedFolderId, folder.FolderId.Id)
        );
}
